import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaColunas, getListaTickets } from 'src/redux/slices/chamados';
import useAuth from 'src/hooks/useAuth';
import useNovoChamado from 'src/hooks/useNovoChamado';
import Iconify from 'src/components/Iconify';
import { SkeletonKanbanColumn } from 'src/components/skeleton';
import { KanbanColumn } from 'src/sections/@dashboard/tickets';
import { NovoChamado } from 'src/sections/@dashboard/tickets/ChamadosNovoChamado';
import ChamadosHeader from 'src/sections/@dashboard/chamados/ChamadosHeader';
import { CHAMADOS_DESIGN } from 'src/sections/@dashboard/chamados/Chamados.design';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import actionListaTagsUsuarios from 'src/actions/chamados/tags/actionListaTagsUsuario';

const D = CHAMADOS_DESIGN;

export default function ChamadosPage() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { colunas } = useSelector((state) => state.chamados);
  const { novoChamadoProps, handleOpenNovoChamado } = useNovoChamado();
  const [listaTags, setListaTags] = useState([]);

  const ordemColunas = ['pendente', 'aberto', 'recusado'];

  function isEmpty(obj) {
    if (!obj) return true;
    return Object.keys(obj).length === 0;
  }

  async function buscarListaTags() {
    try {
      let querys = `?clienteId=${user.clienteId}`;
      const response = await actionListaTagsUsuarios(querys);
      setListaTags(response.data.data);
    } catch (error) {}
  }

  useEffect(() => {
    buscarListaTags();
    dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id, filial: '' }));
    dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: '' }));
  }, [dispatch]);

  return (
    <div className={D.page.container}>
      <ChamadosHeader onCriarChamado={handleOpenNovoChamado} />

      <div className={D.kanban.container}>
        <ScrollArea className={D.kanban.scrollArea}>
          {isEmpty(colunas) ? (
            <div className={D.emptyState.container}>
              <div className={D.emptyState.iconBox}>
                <Iconify icon="mdi:inbox" width={32} />
              </div>
              <h3 className={D.emptyState.title}>Sem chamados por enquanto</h3>
              <p className={D.emptyState.description}>
                Mantenha a plataforma aberta para receber novos chamados e tickets.
              </p>
              <button onClick={handleOpenNovoChamado} className={D.emptyState.link}>
                Criar meu primeiro chamado
              </button>
            </div>
          ) : (
            <div className={D.kanban.columnsRow}>
              {!ordemColunas.length ? (
                <SkeletonKanbanColumn />
              ) : (
                ordemColunas.map((columnId, index) => (
                  <div key={columnId} className={D.kanban.column}>
                    <KanbanColumn listaTags={listaTags} index={index} column={colunas[columnId]} />
                  </div>
                ))
              )}
            </div>
          )}
        </ScrollArea>
      </div>

      <NovoChamado {...novoChamadoProps} />
    </div>
  );
}
